<template>
  <b-modal v-model="inputVal.show"
           title="修改圖片"
           size="xl"
           centered
           cancel-title="取消"
           ok-title="確定"
           @ok.prevent="handleCrop"
  >
    <ImageCropper v-if="inputVal.image"
                  v-model="cropData"
                  :src="inputVal.image | imagePath(uploadType)"
                  :original="inputVal.image | imagePath(uploadType, 'original')"
                  :disabled="loading"
    ></ImageCropper>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex';
import {
  pluck,
  switchMap,
} from 'rxjs/operators';
import vModelMixin from '@/mixins/v-model';
import http from '@/helpers/http';
import imagePath from '@/filters/image-path';
import ImageCropper from '@/components/image/ImageCropper.vue';

export default {
  mixins: [vModelMixin],
  components: {
    ImageCropper,
  },
  props: {
    uploadType: String,
    publicApi: Boolean,
  },
  data: () => ({
    postBody: null,
    cropData: null,
    loading: false,
  }),
  computed: {
    ...mapGetters(['role']),
    apiBase() {
      return this.publicApi ? 'public' : this.role;
    },
  },
  filters: {
    imagePath,
  },
  subscriptions() {
    const cropImage$ = (data) => http({
      method: 'post',
      url: `/agc-${this.apiBase}-api/upload/cropImage`,
      data,
    }, {
      next: () => {
        this.$emit('cropped', this.inputVal.image);
      },
      error: () => {
        this.$emit('error');
      },
      complete: () => {
        this.loading = false;
        this.inputVal.show = false;
        this.inputVal.image = false;
      },
    });

    return {
      crop: this.$watchAsObservable('postBody')
        .pipe(
          pluck('newValue'),
          switchMap(cropImage$),
        ),
    };
  },
  methods: {
    handleCrop() {
      this.loading = true;
      this.postBody = {
        image: this.inputVal.image,
        uploadType: this.uploadType,
        cropData: this.cropData,
      };
    },
  },
};
</script>

<style scoped>

</style>
